import Alpine from 'alpinejs';
import axios from 'axios';

Alpine.data('personalRequestApplication', () => ({
  currentStep: 0,
  showPersonalRequestApplication: false,
  jobPreference: '',
  workAreaLabel: '',
  workArea: '',
  employmentTypeLabel: '',
  employmentType: '',
  workingHoursLabel: '',
  workingHours: '',
  locationPreference: '',
  companyName: '',
  contactPerson: '',
  email: '',
  phone: '',
  privacy: false,
  referral: '',
  referralLabel: '',
  isReferralOpen: false,
  errors: {
    jobPreference: false,
    locationPreference: false,
    workArea: false,
    employmentType: false,
    workingHours: false,
    companyName: false,
    contactPerson: false,
    email: false,
    phone: false,
    privacy: false,
    referral: false,
  },
  steps: [
    {
      stepNumber: 0,
      requiredFields: [],
      stepValid: false,
    },
    {
      stepNumber: 1,
      requiredFields: ['workArea'],
      stepValid: false,
    },
    {
      stepNumber: 2,
      requiredFields: ['employmentType'],
      stepValid: false,
    },
    {
      stepNumber: 3,
      requiredFields: ['workingHours'],
      stepValid: false,
    },
    {
      stepNumber: 4,
      requiredFields: ['locationPreference'],
      stepValid: false,
    },
    {
      stepNumber: 5,
      requiredFields: ['companyName','contactPerson', 'email', 'phone', 'privacy'],
      stepValid: false,
    },
    {
      stepNumber: 6,
      requiredFields: ['referral'],
      stepValid: false,
    },
  ],

  scrollUp() {
    window.scrollBy({
      top: -800, // could be negative value
      left: 0,
      behavior: 'smooth'
    });
  },

  closeModal() {
    const self = this;
    self.currentStep = 0;
    self.jobPreference = '';
    self.workAreaLabel = '';
    self.employmentTypeLabel = '';
    self.workingHoursLabel = '';
    self.workArea = '';
    self.employmentType = '';
    self.workingHours = '';
    self.locationPreference = '';
    self.companyName = '';
    self.contactPerson = '';
    self.email = '';
    self.phone = '';
    self.privacy = false;
    self.referral = '';
    self.referralLabel = '';
    self.isReferralOpen = false;
    Object.keys(self.errors).forEach(key => {
      self.errors[key] = false;
    });
    self.showPersonalRequestApplication = false;
  },

  nextStep() {
    const self = this;
    const currenStepIndex = self.steps.findIndex(stepFields => stepFields.stepNumber === self.currentStep);
    const errorFields = currenStepIndex !== -1 ? self.steps[currenStepIndex].requiredFields.filter(step => self.errors[step]) : [];
    const missingFields = currenStepIndex !== -1 ? self.steps[currenStepIndex].requiredFields.filter(field => !self[field]) : [];
    if (errorFields.length > 0) {
      self.steps[currenStepIndex].stepValid = false;
      return;
    }
    if (missingFields.length > 0) {
      missingFields.forEach(missingField => {
        self.errors[missingField] = true;
      });
      self.steps[currenStepIndex].stepValid = false;
      return;
    } else if (currenStepIndex !== -1) {
      self.steps[currenStepIndex].requiredFields.map(requiredStepField => {
        self.errors[requiredStepField] = false;
      });
      self.steps[currenStepIndex].stepValid = true;
    }
    self.currentStep += 1;
  },

  submitForm(el) {
    const self = this;
    const { submitUrl } = el.dataset;
    if (!Object.values(self.errors).find(value => value)) {
      // submit
      const postData = {
        webform_id: 'personal_request_application',
        jobpreference: this.jobPreference,
        workarea: this.workArea,
        employmenttype: this.employmentType,
        workinghours: this.workingHours,
        locationpreference: this.locationPreference,
        companyname: this.companyName,
        contactperson: this.contactPerson,
        email: this.email,
        phone: { phone: this.phone },
        referral: this.referral,
        privacy: this.privacy,
      };
      axios({
        method: 'GET',
        url: `/session/token`,
        headers: {
          Accept: 'application/vnd.api+json',
        },
      })
        .then(response => response)
        .then(token => {
          const headers = {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/json',
            'X-CSRF-Token': token.data,
          };
          axios
            .post(submitUrl, postData, {
              headers: headers,
            })
            .then(response => {
              self.closeModal();
            })
            .catch(err => {
              console.warn(err);
              // only for testing
              self.closeModal();
            });
        });
    }
  },

  validatePhone(event) {
    const self = this;
    const regex = new RegExp(/^[\d\/+ ]*$/);
    const value = event.target.value;
    if (!regex.test(value)) {
      self.errors.phone = true;
      return;
    } else {
      self.errors.phone = false;
    }
  },

  validateEMail(event) {
    const self = this;
    const regex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
    const value = event.target.value;
    if (!regex.test(value)) {
      self.errors.email = true;
      return;
    } else {
      self.errors.email = false;
    }
  },

  previousStep(step = false) {
    const self = this;
    if (step) {
      self.currentStep = step;
    } else {
      self.currentStep -= 1;
    }
  },

  openReferralDropdown() {
    const self = this;
    self.isReferralOpen = true;
  },

  selectWorkAreaOption(elm) {
    const self = this;
    self.workAreaLabel = elm.dataset.label;
    self.errors.workArea = false;
  },

  selectEmploymentTypeOption(elm) {
    const self = this;
    self.employmentTypeLabel = elm.dataset.label;
    self.errors.employmentType = false;
  },

  selectWorkingHourOption(elm) {
    const self = this;
    self.workingHoursLabel = elm.dataset.label;
    self.errors.workingHours = false;
  },

  selectReferral(elm) {
    const self = this;
    self.referral = elm.dataset.value;
    self.referralLabel = elm.dataset.label;
    self.isReferralOpen = false;
    self.errors.referral = false;
  },

  validateRequiredInput(event, field) {
    const self = this;
    const { value } = event.target;
    if (value && value.length > 0) {
      self.errors[field] = false;
    } else {
      self.errors[field] = true;
    }
  },

  validateLocationPreferenceInput(event) {
    const self = this;
    const { value } = event.target;
    if (value && value.length > 0) {
      self.errors.locationPreference = false;
    } else {
      self.errors.locationPreference = true;
    }
  },

  validateRequiredCheckbox(event, field) {
    const self = this;
    const { checked } = event.target;
    if (checked) {
      self.errors[field] = false;
    } else {
      self.errors[field] = true;
    }
  },

  clickStepButton(clickedStep) {
    const self = this;
    const clickedStepIndex = self.steps.findIndex(step => step.stepNumber === clickedStep);
    if (self.steps[clickedStepIndex].stepValid) {
      self.currentStep = clickedStep;
    }
  },
}));
